'use client';

import { useState } from 'react';
import SearchBar from '@/componentv2/searchBar/searchBar';
import SearchResultsCaseStudies from '../searchResultsCaseStudies';

interface SearchableCaseStudySectionProps {
  children?: React.ReactNode;
}

const SearchableCaseStudySection = ({
  children,
}: SearchableCaseStudySectionProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  return (
    <>
      <SearchBar onSearch={handleSearch} placeholder="Search case studies..." />
      {searchQuery ? (
        <SearchResultsCaseStudies searchQuery={searchQuery} />
      ) : (
        children
      )}
    </>
  );
};

export default SearchableCaseStudySection;
